<template>
	<inertia-head title="Home" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Welcome to the {{ $page.props.app.name }}!
					</h1>
					<div v-if="$page.props.user.has_col==0 && $page.props.user.current_rank !== 'SILVER'">
						<h2 class="h4 fw-normal text-white-75 fs-sm">
							You can start processing your
							<strong>COL</strong> account opening by clicking the button below
						</h2>
						<a
							:href="$page.props.settings.col_link"
							class="btn btn-alt-secondary btn-lg fw-semibold"
							target="_blank"
						>
							Open COL account
							<i class="fa fa-external-link-alt ms-2"></i>
						</a>
						<p class="mt-4 fw-normal text-white-75 fs-sm">Already have a <strong>COL account?</strong> 
							<a @click="dismissColProcess()" href="javascript:void(0)" :disabled='formColProcess.processing'>
								<div
									v-if="formColProcess.processing"
									class="spinner-border spinner-border-sm text-text ms-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								Click here
							</a>
							 to dismiss this step.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-if="$page.props.is_lifetime==false && is_allowed==1">

		<div class="block block-transparent">
			<div class="block-content block-content-full p-0">
				<img src="/media/banners/gold_lifetime_membership.jpg" style="object-fit: cover;height: 100%;width: 100%;" />
			</div>
			<div class="block-content block-content-full text-center bg-white p-2">
				<div class="row justify-content-center">
					<div class="col-md-8 py-4 text-center">
						<div v-if="time_limit>0" class="row text-center mb-5">
							<div class="col-6 col-md-3">
								<div class="fs-1 fw-bold text-black">{{gold_lifetime_timer.days}}</div>
								<div class="fs-sm fw-medium text-black-50">DAYS</div>
							</div>
							<div class="col-6 col-md-3">
								<div class="fs-1 fw-bold text-black">{{gold_lifetime_timer.hrs}}</div>
								<div class="fs-sm fw-medium text-black-50">HOURS</div>
							</div>
							<div class="col-6 col-md-3">
								<div class="fs-1 fw-bold text-black">{{gold_lifetime_timer.mins}}</div>
								<div class="fs-sm fw-medium text-black-50">MINUTES</div>
							</div>
							<div class="col-6 col-md-3">
								<div class="fs-1 fw-bold text-black">{{gold_lifetime_timer.secs}}</div>
								<div class="fs-sm fw-medium text-black-50">SECONDS</div>
							</div>
						</div>
						<div class="row text-center">
							<div class="col-12">
								<h4>Be One of the First 60 Gold Members Invited to Dinner with Bro. Bo</h4>
								<inertia-link :href="route('member.gold-lifetime-sales-page')" class="btn btn-hero btn-success">View Lifetime Gold Offer</inertia-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>

	<!-- <div v-if="remain_day <= 14 && $page.props.rank_prefix!='S'" class="border border-primary bg-white text-danger m-3">
		<div class="p-3">
			<h5 class="text-center m-0">Please keep your Membership updated so that you continue to be PROTECTED with our P100k Life Insurance and P100k Accident Insurance, <inertia-link :href="route('member.upgrade')">Click Here now</inertia-link>.</h5>
		</div>
	</div> -->

	<div v-if="$page.props.user.qualified_for_pf=='Yes' && $page.props.rank_prefix!='PF'" class="border border-info bg-white text-danger m-3">
		<div class="p-3">
			<h5 class="text-center m-0">You are qualified to PLATINUM FAITHFUL upgrade, <inertia-link :href="route('member.upgrade')">Click Here</inertia-link> to avail.</h5>
		</div>
	</div>

	<div v-if="invest!=null">
		<div v-if="invest.is_verified==0 && (invest.info_complete==0 || invest.risk_investor_type==null)" class="border border-danger bg-white text-danger m-3">
			<div class="p-3">
				<h5 class="text-center m-0">Please update your member information for the investment details. Click the button below:
					<div class="mt-2"><inertia-link :href="route('member.investment.info')" class="btn btn-success">Click Here</inertia-link></div>
				</h5>
			</div>
		</div>
		<div v-if="invest.is_verified==0 && invest.info_complete==1 || invest.risk_investor_type!=null && invest.is_docu_rejected==0" class="alert border border-info bg-white text-info alert-dismissible m-3" role="alert">
	        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
	        <h5 class="alert-heading fs-6 fw-bold mb-1 p-0 content-heading">Application Status</h5>
	        <p class="mb-0">
	          We are verifying your member information within 2-3 business day. Once it's approved, we will proceed to the investment processing of <strong>{{invest.invest_name}}</strong>.
	        </p>
      	</div>
		<div v-if="invest.is_verified==0 && invest.is_docu_rejected==1" class="border border-danger bg-white text-danger m-3">
			<div class="p-3">
				<h5 class="text-center m-0">Your ID TYPE uploaded file were rejected, please update your member information for the investment details. Click the button below:
					<div class="mt-2"><inertia-link :href="route('member.investment.info')" class="btn btn-success">Click Here</inertia-link></div>
				</h5>
			</div>
		</div>
	</div>
	<div v-if="qualified_insurance" class="border border-danger bg-white text-danger m-3">
		<div class="p-3">
			<h5 class="text-center m-0">Please update your information for the insurance details. Click the button below:
				<div class="mt-2"><inertia-link :href="route('member.insurance.index')" class="btn btn-success">Click Here</inertia-link></div>
			</h5>
		</div>
	</div>

	<div v-if="$page.props.user.old_no_ops==1 && $page.props.dev==1" class="border border-info bg-white text-info m-3">
		<div class="content">
			<h4 class="text-center">Hi {{$page.props.user.fname}}! we are moving to a new and better payment facility. We would like to ask you for a few moments to update your payment information.
				<div class="text-center mt-3"><i class="fa fa-hand-point-down text-danger animated bounce infinite"></i></div>
				<div class="mt-2"><inertia-link :href="route('member.credit-card-info')" class="btn btn-info">Click Here</inertia-link></div>
			</h4>
		</div>
	</div>

	<!-- <div v-if="($page.props.is_lifetime || ($page.props.is_lifetime==false && ['PLATINUM','PLATINUM COUPLE'].includes($page.props.user.current_rank))) && $page.props.free_wealthcon!==null" class="border border-info bg-white text-info m-3"> -->
	<div v-if="$page.props.free_wealthcon!==null" class="border border-info bg-white text-info m-3">
		<div class="p-3">
			<h5 class="text-center m-0">You're eligible for a ticket to the <strong>TRC Wealth Conference 2025</strong>—claim it now by clicking the button below to secure your spot before seats run out!
				<div class="mt-2">
					<a :href="'https://tkt.ph/event/'+$page.props.free_wealthcon.event_uuid+'/free-ticket?trc_member='+$page.props.free_wealthcon.code" class="btn btn-success mt-2" target="_blank">To join the physical event click here.</a>
				</div>
			</h5>
		</div>
	</div>

	<div v-if="$page.props.wealth_con!==null" class="border border-info bg-white text-info m-3">
		<div class="p-3">
			<h3 class="text-center m-0">TRC Wealth Conference {{$page.props.wealth_con['year']}} {{$page.props.wealth_con['is_live_con']==1 ? 'Livestream' : 'Replay'}}
				<div class="mt-2">
					<a :href="route('member.wealth-conference')" class="btn btn-success" target="_blank">Click Here</a>
				</div>
			</h3>
		</div>
	</div>


	<div class="content">

		<!-- <div v-if="checklist.length>0 && $page.props.user.checklist_complete==0" class="block block-rounded">
			<div class="block-header border-bottom">
				<div class="block-title">
					TRC Quickstart Checklist
				</div>
			</div>
			<div class="block-content block-content-full">
					<div v-for="(list,l_index) in checklist" class="form-group">
						<div class="form-check">
							<input @click="checklistComplete(l_index)" type="checkbox" :id="'checklist_'+l_index" :checked="list.is_done" class="form-check-input" /> 
							<span v-if="list.is_done==0">{{list.checklist_name}}</span>
							<s v-else>{{list.checklist_name}}</s>
						</div>
					</div>
			</div>
		</div> -->

		<!-- <div v-if="affContest!=null">
			<div class="block block-rounded">
				<div class="text-center">
					<img src="/media/images/trc-contest-banner-2.jpg" class="img img-fluid">
				</div>
				<div class="block-header">
					<div class="block-title text-center"><h3>Top 10 Qualifiers for our {{affContest.title}} Affiliate Contest</h3></div>
				</div>
				<div class="block-content block-content-full">
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th>Name</th>
									<th class="text-end">Points</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(topaff,index) in topTenAff">
									<td>{{topaff.username}} {{(topaff.fname)}} <span v-if="topaff.lname!=''">{{topaff.lname}}.</span></td>
									<td class="text-end">{{topaff.pts}}</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div class="my-3 text-center">
						<inertia-link :href="route('member.affiliate-program.affiliate-contest')" class="btn btn-info">More Details</inertia-link>
					</div>

				</div>
			</div>
		</div> -->


		<div class="home-widget my-2">
			<div class="row mb-2">
				<div v-if="$page.props.user.current_rank !== 'SILVER'" class="col-md-6" :class="{'col-xl-4':(shortCards['live'] || shortCards['zoom_event']), 'col-xl-6':(!shortCards['live'] && !shortCards['zoom_event'])}">
					<inertia-link :href="route('member.recommendations.boss')" class="block block-rounded block-transparent border border-secondary block-link-pop">
						<div class="block-content block-content-full ribbon ribbon-left ribbon-modern ribbon-success p-0">
							<div class="ribbon-box ms-4 fs-xs">BOSS RECOMMENDATIONS</div>
							<img :src="shortCards['boss'][0].company_logo_url"/>
							<div class="bg-black-25 home-widget-overlay"></div>
						</div>
						<div class="block-content block-content-full text-center bg-white p-2">
							<div class="row" style="height: 48px;align-content: center;">
								<div v-for="(boss,bIndex) in shortCards['boss']" class="mb-0 fw-bold" :class="{'col-12':shortCards['boss'].length==1,'col-6':shortCards['boss'].length>1}">{{boss.stock}}</div>
							</div>
						</div>
					</inertia-link>
				</div>
				<div v-if="$page.props.user.current_rank !== 'SILVER'" class="col-md-6" :class="{'col-xl-4':(shortCards['live'] || shortCards['zoom_event']), 'col-xl-6':(!shortCards['live'] && !shortCards['zoom_event'])}">
					<inertia-link :href="route('member.stock-updates-details',{stock_update_uuid:shortCards['stock_updates'].stock_update_uuid})" class="block block-rounded block-transparent border border-secondary block-link-pop">
						<div class="block-content block-content-full ribbon ribbon-left ribbon-modern ribbon-info p-0">
							<div class="ribbon-box ms-4 fs-xs">STOCK UPDATES</div>
							<img :src="shortCards['stock_updates'].stock_image_url"/>
							<div class="bg-black-25 home-widget-overlay"></div>
						</div>
						<div class="block-content block-content-full text-center bg-white p-2">
							<div class="row" style="height: 48px;align-content: center;">
								<div class="col-12 mb-0 fw-bold">{{shortCards['stock_updates'].stock_title}}</div>
							</div>
						</div>
					</inertia-link>
				</div>
				<div v-if="$page.props.user.current_rank !== 'SILVER'" class="col-md-6" :class="{'col-xl-4':(shortCards['live'] || shortCards['zoom_event']), 'col-xl-6':(!shortCards['live'] && !shortCards['zoom_event'])}">
					<inertia-link :href="route('member.updates.stock-alert')" class="block block-rounded block-transparent border border-secondary block-link-pop">
						<div class="block-content block-content-full ribbon ribbon-left ribbon-modern ribbon-primary p-0">
							<div class="ribbon-box ms-4 fs-xs">STOCK ALERT</div>
							<img src="/media/images/city_night.jpg"/>
							<div class="bg-black-25 home-widget-overlay"></div>
						</div>
						<div class="block-content block-content-full text-center bg-white p-2">
							<div class="row" style="height: 48px;align-content: center;">
								<div class="col-12 mb-0 fw-bold">Stock Alert For {{shortCards['stock_alert'].display_date}}</div>
							</div>
						</div>
					</inertia-link>
				</div>

				<div v-if="shortCards['live']" class="col-md-6 col-xl-4">
					<inertia-link :href="route('member.trc-live.video-library')" class="block block-rounded block-transparent border border-secondary block-link-pop">
						<div class="block-content block-content-full ribbon ribbon-left ribbon-modern ribbon-danger p-0">
							<div class="ribbon-box ms-4 fs-xs">TRC LIVE</div>
							<img src="/media/images/live.jpg"/>
							<div class="bg-black-25 home-widget-overlay"></div>
						</div>
						<div class="block-content block-content-full text-center bg-white p-2">
							<div class="row" style="height: 48px;align-content: center;">
								<div class="col-12 mb-0 fw-bold">{{shortCards['live'] ? shortCards['live'].start_display : 'No Live Schedule'}}</div>
							</div>
						</div>
					</inertia-link>
				</div>
				<div v-if="shortCards['zoom_event']" class="col-md-6 col-xl-4">
					<inertia-link :href="route('member.events')" class="block block-rounded block-transparent border border-secondary block-link-pop">
						<div class="block-content block-content-full ribbon ribbon-left ribbon-modern ribbon-warning p-0">
							<div class="ribbon-box ms-4 fs-xs">ZOOM EVENT</div>
							<img src="/media/images/zoom_event.jpg"/>
							<div class="bg-black-25 home-widget-overlay"></div>
						</div>
						<div class="block-content block-content-full text-center bg-white p-2">
							<div class="row" style="height: 48px;align-content: center;">
								<div class="col-12 mb-0 fw-bold">{{shortCards['zoom_event'] ? shortCards['zoom_event'].start_display : 'No Zoom Event'}}</div>
							</div>
						</div>
					</inertia-link>
				</div>
				<div class="col-md-6" :class="{'col-xl-4':(shortCards['live'] || shortCards['zoom_event']), 'col-xl-6':(!shortCards['live'] && !shortCards['zoom_event'])}">
					<inertia-link :href="route('member.trc-live.video-library')+'?tab=library'" class="block block-rounded block-transparent border border-secondary block-link-pop">
						<div class="block-content block-content-full ribbon ribbon-left ribbon-modern p-0">
							<div class="ribbon-box bg-elegance text-white ms-4 fs-xs">LATEST VIDEO</div>
							<img :src="shortCards['latest_video'].video_img_url"/>
							<div class="bg-black-25 home-widget-overlay"></div>
						</div>
						<div class="block-content block-content-full text-center bg-white p-2">
							<div class="row" style="height: 48px;align-content: center;">
								<div class="col-12 mb-0 fw-bold">{{shortCards['latest_video'].title}}</div>
							</div>
						</div>
					</inertia-link>
				</div>

			</div>
		</div>

		<div class="row g-xxl-5 items-push py-4">
			<div v-if="announcements.length>0" class="col-12 mb-6">
				<h4 class="mb-0 border-bottom border-3 border-danger">Updates</h4>
				<div v-for="(announcement,a_index) in announcements" class="block mb-0 border-bottom" :class="{'border-top':a_index>0}">
					<div class="block-content block-content-full">
						<div class="fw-semibold h2 mb-0">{{announcement.title}}</div>
						<div class="fs-xs text-muted fst-italic">{{announcement.posted_date}}</div>
		                <div class="fs-sm mt-4" style="white-space: pre; white-space:break-spaces;" v-html="announcement.description">
			                
			            </div>
		                <div v-if="announcement.announcement_img_url!==null" class="mt-5 text-center overflow-hidden">
		                	<img :src="announcement.announcement_img_url" class="img img-fluid" />
		                </div>
					</div>
				</div>
			</div>

			<div v-if="$page.props.flogin_day_count<7" class="col-12 mb-7">
            	<h1 class="text-center mb-2">Welcome Video</h1>
                <div class="embed-responsive">
                    <iframe class="shadow-sm embed-responsive-item" :src="'https://player.vimeo.com/video/'+$page.props.settings.welcome_vimeo_id" allowfullscreen></iframe>
                </div>
            </div>

			<div v-if="homeVideo" class="col-12">
				<div class="bg-white p-4 border-top border-bottom border-3 border-warning mb-5">
					<h1 class="text-center mb-2">{{homeVideo.title}}</h1>
	                <div class="embed-responsive">
	                    <iframe class="shadow-sm embed-responsive-item" src="https://player.vimeo.com/video/{{homeVideo.video_id}}" allowfullscreen></iframe>
	                </div>
		        </div>
	        </div>

	        

			<!-- <div class="col-12">
				<h4 class="mb-1 border-bottom border-2 border-info">Recent Updates</h4>
				<div v-for="(new_update,n_index) in newUpdates" class="block mb-1">
					<div class="block-content block-content-full">
						<div class="fs-sm fw-semibold">{{new_update.title}}</div>
		                <div class="fs-sm text-muted">{{new_update.description}}</div>
		                <div class="fs-sm">
		                    <inertia-link class="text-info" :href="new_update.link" data-toggle="layout" data-action="side_overlay_close">Click Here</inertia-link>
		                </div>
		                <div class="fs-xs text-muted">{{new_update.date_short}}</div>
					</div>
				</div>
			</div> -->

		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);
	
import { watch, onMounted, ref, reactive } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster'
import { useForm, usePage } from '@inertiajs/inertia-vue3'

export default {
	props:{
		is_allowed 				: Number,
		flash 					: Object,
		remain_day 				: Number,
		qualified_insurance 	: Boolean,
		invest 					: Boolean,
		// affContest 			: Object,
		// topTenAff 			: Object,
		announcements 			: Object,
		checklist 				: Object,
		homeVideo 				: Object,
		shortCards 				: Object,
		gold_lifetime 			: Object,
		ops_lifetime 			: Object,
	},
	layout: AuthLayout,
	setup(props) {

		const toast = createToaster();

		const time_limit = ref(0);

		const gold_lifetime_timer = reactive({days:0,hrs:0,mins:0,secs:0});
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}
			
		})

		const formChecklist = useForm({
			checklist_id 	: null,
			checklist_name 	: null,
			is_done 		: 0,
		})

		const formColProcess = useForm({
			has_col 		: 1,
		})

		const checklistComplete = (_index)=>{
			let checklist 			= props.checklist[_index];
			let member_checklist_id = checklist.member_checklist_id;

			formChecklist.checklist_id 		= checklist.checklist_id;
			formChecklist.checklist_name 	= checklist.checklist_name;
			formChecklist.is_done 			= ($("#checklist_"+_index).is(':checked') ? 1 : 0);

			formChecklist.put(route("member.put.checklist",{member_checklist_id: member_checklist_id}),{
				preserveState: true,
				preserveScroll: true,
				only:['checklist']
			});
		}

		const dismissColProcess = ()=>{

			formColProcess.put(route("member.put.col-process"),{
				preserveState: true,
				preserveScroll: true,
			});
		}

		if(props.gold_lifetime.result=="success")
		{
			watch(time_limit,(value,old_value)=>{

				let gold_timer = null;
				let days = 0, hrs = 0, mins = 0, secs = 0;

				if (value>0 && value!=old_value) {

					days 	= Math.floor(time_limit.value/60/60/24);
					hrs 	= Math.floor(time_limit.value/60/60);
					mins 	= Math.floor(time_limit.value/60);
					secs 	= value;

					secs 	= secs % 60;
					mins 	= mins % 60;
					hrs 	= hrs % 24;
					days 	= days % 24;

					gold_lifetime_timer.days 	= (days>9 ? days : "0" + days);
					gold_lifetime_timer.hrs 	= (hrs>9 ? hrs : "0" + hrs);
					gold_lifetime_timer.mins 	= (mins>9 ? mins : "0" + mins);
					gold_lifetime_timer.secs 	= (secs>9 ? secs : "0" + secs);

					clearTimeout(gold_timer);

					gold_timer = setTimeout(function(){
					    time_limit.value--;
					},1000);

				}

			})

			time_limit.value = props.gold_lifetime.data.time_limit;
		}

		return{
			formChecklist,
			formColProcess,
			checklistComplete,
			time_limit,
			gold_lifetime_timer,
			dismissColProcess,
		}

	},
}
</script>
